<template>
  <el-form
    ref="form"
    :label-position="labelPosition"
    :model="form"
    :rules="rules"
    label-width="80px"
    class="article-form"
  >
    <el-form-item
      label="文章标题"
      prop="title"
    >
      <el-input
        v-model="form.title"
        placeholder="文章标题"
        maxlength="1024"
      ></el-input>
    </el-form-item>
    <el-form-item
      label="文章类型"
      prop="type"
    >
      <el-select
        style="width: 100%"
        v-model="form.type"
        placeholder="文章类型"
        clearable
      >
        <el-option
          v-for="(item,index) in typeList"
          :key="index"
          :label="item.label"
          :value="item.key"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item
      label="文章分类"
      prop="category"
    >
      <el-select
        style="width: 100%"
        v-model="form.category"
        placeholder="文章分类"
        clearable
      >
        <el-option
          v-for="(item,index) in categoryList"
          :key="index"
          :label="item.label"
          :value="item.label"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item
      label="指向外链"
      prop="targetLink"
    >
      <el-input
        v-model="form.targetLink"
        placeholder="指向外链"
      ></el-input>
    </el-form-item>
    <el-form-item
      label="摘要"
      prop="summary"
    >
      <el-input
        type="textarea"
        placeholder="请输入"
        rows="3"
        manlength="512"
        v-model="form.summary"
        show-word-limit
      ></el-input>
    </el-form-item>
    <el-form-item
      label="标签"
      prop="tags"
    >
      <tags-editor
        v-model="form.tags"
      ></tags-editor>
    </el-form-item>
    <el-form-item
      label="文章内容"
      prop="image"
    >
      <el-input
        v-model="form.image"
        placeholder="图片链接"
      >
        <ossUploader
          slot="append"
          @uploaded="uploadHandle"
        >
        </ossUploader>
      </el-input>
    </el-form-item>
    <el-form-item
      label="文章内容"
      prop="content"
    >
      <quill-editor
        ref="editor"
        :defaultValues="form.content"
        @catchData="catchData"
      ></quill-editor>
    </el-form-item>
  </el-form>
</template>

<script>
import formLabalPosition from "@/mixins/formLabalPosition";
import tagsEditor from "@/components/common/tagsEditor"
import quillEditor from "@/components/public/quillEditor";
import ossUploader from "@/components/public/ossUploader";
let origin = {
  title: '',
  type: '',
  category: '',
  targetLink: '',
  summary: '',
  tags: '',
  image: '',
  content: '',
}
export default {
  name: "articleForm",
  components: {
    quillEditor,
    ossUploader,
    tagsEditor,
  },
  props: {
    formData:{
      type: Object,
      default(){
        return {
          id: ''
        };
      }
    }
  },
  data() {
    return {
      typeList: [
        { key: 1,label: '普通文章' },
        { key: 5,label: '帮助中心' },
      ],
      categoryList: [
        { key: 'yanbao',label: '研报' },
        { key: 'celve',label: '策略' },
        { key: 'ask',label: '问答' },
        { key: 'help',label: '帮助中心' },
        { key: 'tech',label: '交易技术' },
        { key: 'analisy',label: '技术分析' },
      ],
      form: JSON.parse(JSON.stringify(origin)),
      rules: {
        title: [
          { required:true, message: '标题不能为空', trigger: 'blur' },
        ],
        type: [
          { required:true, message: '请选择,文章类型不能为空', trigger: 'change' },
        ],
        category: [
          { required:true, message: '请选择,分类不能为空', trigger: 'change' },
        ],
        targetLink: [
          { required:true, message: '请输入', trigger: 'blur' },
        ],
        // summary: [
        //   { required:true, message: '请输入', trigger: 'blur' },
        // ],
        // image: [
        //   { required:true, message: '请输入', trigger: 'blur' },
        // ],
        content: [
          { required:true, message: '请输入文章内容', trigger: 'blur' },
        ],
      },
    }
  },
  watch:{
    formData:{
      handler(newValue){
        if(newValue.id){
          this.assigen(newValue);
        }
      },
      deep: true,
    }
  },
  mixins: [formLabalPosition],
  methods: {
    reset(){
      this.form = JSON.parse(JSON.stringify(origin));
    },
    assigen(data){
      this.$http({
        url: `/wx/manage/article/info/${data.id}`,
        method: "get",
      }).then((data) => {
        if (data.code === 200) {
          this.form = data.article;
          /*this.form.id = data.id;
          this.form.title = data.title;
          this.form.type = data.type;
          this.form.category = data.category;
          this.form.targetLink = data.targetLink;
          this.form.summary = data.summary;
          this.form.tags = data.tags;
          this.form.image = data.image;
          this.form.content = data.content;*/
        }
      });
    },
    selfValidate() {
      this.$refs.form.validate((valid) => {
        if(valid){
          this.$emit('submit',this.form);
        }
      })
    },
    selfClear(){
      this.$refs.form.clearValidate();
      this.$refs.form.resetFields();
      this.reset();
    },
    catchData(content){
      this.form.content = content;
    },
    uploadHandle(url){
      this.form.image = url;
    }
  },
}
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/variable';
.article-form {
  /deep/ .el-input-group__append {
    cursor: pointer;
    background-color: $themeColor;
    color: #ffffff;
  }
}
</style>
